{
    /* eslint-disable react/no-unknown-property */
}
import React from "react";
import "./DashboardWidgetItem.scss";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = {
    title: string;
    dragFn: (item: string) => void;
};

export const DashboardWidgetItem: React.FC<Props> = (props) => {
    return (
        <div
            className={"droppable-element DashboardWidgetItem"}
            draggable={true}
            unselectable="on"
            // this is a hack for firefox
            // Firefox requires some kind of initialization
            // which we can do by adding this attribute
            // @see https://bugzilla.mozilla.org/show_bug.cgi?id=568313
            onDragStart={(e) => {
                e.dataTransfer.setData("text/plain", "");
                props.dragFn(props.title);
            }}>
            <OwLabel title={props.title} noBottomMargin={true} />
        </div>
    );
};
